// jsdom marks `window.location` and every one of its members as unforgeable from v21 on, so a test
// can no longer replace the object or spy on the `href` setter. Routing the one assignment we make
// through this module keeps the redirect assertable: consumers mock './redirect', and this module's
// own test passes a plain object as `target`.
export const redirectTo = (url: string, target: Pick<Location, 'href'> = window.location): void => {
  target.href = url;
};
